module.exports = __webpack_public_path__ + "static/media/miner-normal-yeti.7d871874.png";